import { render, staticRenderFns } from "./InspectionServiceForm.vue?vue&type=template&id=492bf48c"
import script from "./InspectionServiceForm.vue?vue&type=script&lang=js"
export * from "./InspectionServiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports